import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function SuperAdminLogin() {
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const { superAdminLogin } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!loginId || !password) return;

    setLoading(true);
    try {
      const { data } = await api.post("/auth/super-admin/login", {
        login_id: loginId,
        password,
      });

      superAdminLogin({
        login_id: loginId,
        token: data.token,
      });

      toast.success("Super-admin access granted");
      nav("/super-admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-950 px-4">
      <div className="w-full max-w-md rounded-2xl border border-zinc-800 bg-white p-8 shadow-2xl">
        <div className="mb-8">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500">
            Super Admin
          </p>
          <h1 className="mt-3 text-3xl font-semibold tracking-tight text-zinc-900">
            Sign in
          </h1>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label htmlFor="login-id" className="mb-2 block text-sm font-medium text-zinc-700">
              Login ID
            </label>
            <Input
              id="login-id"
              type="text"
              value={loginId}
              onChange={(e) => setLoginId(e.target.value)}
              placeholder="superadmin"
              className="h-11 rounded-md border-zinc-200"
              required
            />
          </div>

          <div>
            <label htmlFor="password" className="mb-2 block text-sm font-medium text-zinc-700">
              Password
            </label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="h-11 rounded-md border-zinc-200"
              required
            />
          </div>

          <Button
            type="submit"
            className="w-full h-11 rounded-md bg-zinc-950 text-white hover:bg-zinc-800"
            disabled={loading}
          >
            {loading ? "Signing in..." : "Log in"}
          </Button>
        </form>

        <div className="mt-6 text-center text-sm text-zinc-500">
          <Link to="/" className="hover:text-zinc-900">
            Back to Growithevent
          </Link>
        </div>
      </div>
    </div>
  );
}